import translate from '@/utils/translate';
import {PHASE, Phase} from '@/config/contentSubmissionPhases';

type EmptyStateContent = {
  title: string;
  description?: string;
};

function getEmptyStateContent(phase: Phase | undefined): EmptyStateContent {
  switch (phase) {
    case PHASE.ALL:
      return {
        title: translate('Your creators are cooking'),
        description: translate(
          "Content lands here once they upload. We'll ping you when it drops."
        ),
      };
    case PHASE.PENDING:
      return {
        title: translate('All caught up.'),
        description: translate('Go grab a Pepsi — you earned it.'),
      };
    case PHASE.REJECTED:
      return {title: translate('No edits requested')};
    case PHASE.ACCEPTED:
      return {title: translate('No approved assets yet')};
    case PHASE.ARCHIVED:
      return {title: translate('No archived assets')};
    default:
      return {title: translate('No content submissions')};
  }
}

export default getEmptyStateContent;
